import { useContext } from 'react'
import { AppAuthContext } from '../constants/index'

const useAppAuth = () => useContext(AppAuthContext)
export default useAppAuth
